import api from './api';

export type DiligenciaStatus = 'PENDENTE' | 'EM_VERIFICACAO' | 'RESOLVIDA';

export interface DiligenciaDocumentoDTO {
  id: string;
  instituicaoId: string;
  planoTrabalhoId?: string;
  mensagem: string;
  enviadoPor: string;
  enviadoEm: string;
  documentosIds?: string[];
  lida: boolean;
  lidaEm?: string;
  status: DiligenciaStatus;
  resolvidoPor?: string;
  resolvidoEm?: string;
  resolucaoObservacao?: string;
  verificadoPor?: string;
  verificadoEm?: string;
  rejeicaoMotivo?: string;
}

const diligenciaDocumentoService = {
  enviar(instituicaoId: string, mensagem: string, documentosIds?: string[], planoTrabalhoId?: string) {
    return api.post<DiligenciaDocumentoDTO>(`/diligencias-documentos/instituicao/${instituicaoId}`, {
      mensagem,
      documentosIds: documentosIds ?? [],
      planoTrabalhoId,
    });
  },

  listar(instituicaoId: string) {
    return api.get<DiligenciaDocumentoDTO[]>(`/diligencias-documentos/instituicao/${instituicaoId}`);
  },

  listarPorPlano(planoTrabalhoId: string) {
    return api.get<DiligenciaDocumentoDTO[]>(`/diligencias-documentos/plano/${planoTrabalhoId}`);
  },

  contarNaoLidas(instituicaoId: string) {
    return api.get<{ count: number }>(`/diligencias-documentos/instituicao/${instituicaoId}/nao-lidas`);
  },

  marcarLida(id: string) {
    return api.put(`/diligencias-documentos/${id}/lida`);
  },

  // Operador marca que já providenciou o que foi pedido — envia para confirmação do Convênios
  resolver(id: string, observacao?: string) {
    return api.put<DiligenciaDocumentoDTO>(`/diligencias-documentos/${id}/resolver`, { observacao });
  },

  // Convênios confirma (aprovado=true → resolvida) ou rejeita (aprovado=false → volta para o operador)
  verificar(id: string, aprovado: boolean, motivoRejeicao?: string) {
    return api.put<DiligenciaDocumentoDTO>(`/diligencias-documentos/${id}/verificar`, { aprovado, motivoRejeicao });
  },

  // Área de trabalho do Convênios: diligências aguardando ação do operador
  listarPendentes() {
    return api.get<DiligenciaDocumentoDTO[]>('/diligencias-documentos/pendentes');
  },

  // Área de trabalho do Convênios: diligências que o operador resolveu e aguardam confirmação
  listarEmVerificacao() {
    return api.get<DiligenciaDocumentoDTO[]>('/diligencias-documentos/em-verificacao');
  },
};

export default diligenciaDocumentoService;
